import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  z-index: 21;
  background: rgba(0,0,0,0.5);
`;

const Dimmed = () => (
    <Wrapper tabIndex="0">

    </Wrapper>
);

export default Dimmed;



// WEBPACK FOOTER //
// ./src/components/Shared/Dimmed.js